import { render, staticRenderFns } from "./simpleQuestion.vue?vue&type=template&id=5498d227&scoped=true&"
import script from "./simpleQuestion.vue?vue&type=script&lang=js&"
export * from "./simpleQuestion.vue?vue&type=script&lang=js&"
import style0 from "./simpleQuestion.vue?vue&type=style&index=0&id=5498d227&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5498d227",
  null
  
)

component.options.__file = "simpleQuestion.vue"
export default component.exports